import DealerInventory from "./dealer-inventory.container";

export default DealerInventory;
